import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

export default function CategoryNavSection() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-foreground-950">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium border border-background-50/20 text-background-50/70 mb-4">
              分类浏览
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50 text-balance">
              探索你喜欢的<span className="text-accent-500">漫画类型</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-400 max-w-md">
            无论你喜欢热血格斗、恋爱甜宠还是悬疑推理，这里都有你想要的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200 transition-colors duration-300"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name}漫画分类`}
                  title={`${cat.name} - 51漫画分类`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.count} 部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}